export default "__VITE_ASSET__65aea0fe__"